'use strict';

angular.module('atex.art').factory('ArtLocalizationService', [
  '$q',
  '$location',
  '$translate', 
function ArtLocalizationService($q, $location, $translate) {
  
  var localizationReady = $q.defer();

  var whenReady = function() {
    return localizationReady.promise;
  };

  var init = function() {
    var params = $location.search();
    
    function getInitialLanguage() {
      function isRequestedLocaleValid() {
        return $translate.getAvailableLanguageKeys().indexOf($translate.negotiateLocale(params.locale)) >= 0;
      }
      return isRequestedLocaleValid() ? params.locale : $translate.resolveClientLocale();
    }

    $translate.use(getInitialLanguage()).then(function() {
      localizationReady.resolve();
    });  
  };

  var translate = function(keys) {
    return whenReady().then(function() {
      return $translate(keys);
    });
  };

  return {
    whenReady: whenReady,
    init: init,
    translate: translate
  };
}]);